import React from "react";
import Homepage from "./Homepage/Homepage.js";

function App() {
  return <Homepage />;
}

export default App;
